import {
    IActionContext,
    CacheType,
    IActionInput,
    createObservableDataAction,
    IAction,
    ICreateActionContext
} from '@msdyn365-commerce/core';
import { OrgUnitLocation } from '@msdyn365-commerce/retail-proxy';
import { getOrgUnitLocationsByAreaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/OrgUnitsDataActions.g';

export class GetAllStoresInput implements IActionInput {
    constructor() {}

    public getCacheKey = () => 'stores';
    public getCacheObjectType = () => 'HEI-AllStores';
    public dataCacheType = (): CacheType => 'application';
}

async function action(input: GetAllStoresInput, ctx: IActionContext): Promise<OrgUnitLocation[]> {
    const stores = await getOrgUnitLocationsByAreaAsync({ callerContext: ctx }, {});
    return stores;
}

export default createObservableDataAction({
    action: <IAction<OrgUnitLocation[]>>action,
    input: (context: ICreateActionContext) => {
        return new GetAllStoresInput();
    }
});
